import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/surveys/edit/Page";

export const PATH = (id: number): string => `/vendors/settings/surveys/${id}`;

function SurveySetting() {
	return (
		<>
			<NskHead title="アンケート編集" />
			<VendorLayoutV2>
				<Component />
			</VendorLayoutV2>
		</>
	);
}

export default SurveySetting;
